function isIE() {
  const ua = window.navigator.userAgent.toUpperCase();
  return ua.includes('TRIDENT/') || ua.includes('MSIE');
}

export default isIE;
